// @flow
import { connect } from 'react-redux';

import {
  toggleCoordinateInputDialog,
  setGeometryFormat,
  submitCoordinateList,
} from 'actions/coordinateInputDialog';
import CoordinateInputDialog from './CoordinateInputDialog';

const mapStateToProps = ({ coordinateInputDialog }) => coordinateInputDialog;

const mapDispatchToProps = {
  toggleCoordinateInputDialog,
  setGeometryFormat,
  submitCoordinateList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoordinateInputDialog);



// WEBPACK FOOTER //
// ./components/CoordinateInputDialog/index.js